import { Component, Input } from "@angular/core";
import { Tenant } from "../models/tenant";
import { FormGroup, Validators, FormControl, AbstractControl, ValidationErrors } from "@angular/forms";
import { TenantIdentifierDataService } from "../service/tenant-identifier-data.service";
import { TenantIdentifier } from "../models/tenant-identifier";
import { tap, map, catchError } from "rxjs/operators";
import { DialogRef, DialogService } from "@progress/kendo-angular-dialog";
import { Observable, of } from 'rxjs';
import { InlineEditGridComponent } from 'src/app/core/inline-edit-grid.component';

@Component({
  selector: "app-tenant-identifiers",
  templateUrl: "./tenant-identifiers.component.html",
  styleUrls: ["./tenant-identifiers.component.scss"],
})
export class TenantIdentifiersComponent extends InlineEditGridComponent {
  @Input() public tenant: Tenant;
  constructor(
    private dataService: TenantIdentifierDataService,
    private dialogService: DialogService
  ) {
    super();
  }

  protected refresh() {
    this.view = this.dataService
      .get(this.gridState, `&$filter=tenantId eq ${this.tenant.Id}`)
      .pipe(tap(() => (this.loading = false)));
  }

  public addHandler({ sender }) {
    this.closeEditor(sender);
    this.formGroup = new FormGroup({
      Id: new FormControl(0),
      TenantId: new FormControl(this.tenant.Id),
      Type: this.CreateTypeControl(''),
      Value: this.CreateValueControl('')
    });
    sender.addRow(this.formGroup);
  }

  public editHandler({ sender, rowIndex, dataItem }) {
    this.closeEditor(sender);
    this.formGroup = new FormGroup({
      Id: new FormControl(dataItem.Id),
      TenantId: new FormControl(dataItem.TenantId),
      Type: this.CreateTypeControl(dataItem.Type),
      Value: this.CreateValueControl(dataItem.Value)
    });
    this.editedRowIndex = rowIndex;
    sender.editRow(rowIndex, this.formGroup);
  }

  public saveHandler({ sender, rowIndex, formGroup, isNew }) {
    const entity: TenantIdentifier = formGroup.value;
    this.loading = true;
    this.refreshObservable(this.dataService.update(entity, isNew));
    sender.closeRow(rowIndex);
  }

  public removeHandler({ dataItem }) {
    const deleteAction = { text: "Delete", primary: true };
    const cancelAction = { text: "Cancel" };
    const dialog: DialogRef = this.dialogService.open({
      title: "Please confirm",
      content: "Deleting this identifier cannot be undone.",
      actions: [cancelAction, deleteAction],
    });

    dialog.result.subscribe((result) => {
      if (result === deleteAction) {
        this.refreshObservable(this.dataService.delete(dataItem.Id));
      }
    });
  }

  private CreateValueControl(identifier){
    return new FormControl(identifier, {updateOn: 'blur', validators: [Validators.required, Validators.minLength(3), Validators.maxLength(500), Validators.pattern('^[0-9a-zA-Z\.\/:_\-]*$')], asyncValidators: [this.UniqueValue.bind(this)]});
  }

  private CreateTypeControl(type){
    return new FormControl(type, [Validators.required, Validators.minLength(3), Validators.maxLength(50), Validators.pattern('^[a-zA-Z_\-]*$')]);
  }

  UniqueValue(ctl: AbstractControl) : Observable<ValidationErrors | null> {
    if (ctl.pristine)
      return of(null);

    let idCtl = ctl.parent.controls['Id'];

    return this.dataService.identifierCount(+idCtl.value, ctl.value)
    .pipe(
      map(
        r => 
        +r["@odata.count"] > 0 ? { unique: true } : null),
      catchError(() => of(null))
    );
  }   
}
